import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Smokecrib from '../entities/smokecrib'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface SmokecribState extends ListState<Smokecrib>{
    editSmokecrib:Smokecrib
}
class UserMutations extends ListMutations<Smokecrib>{

}
class SmokecribModule extends ListModule<SmokecribState,any,Smokecrib>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Smokecrib>(),
        filterlist:new Array<Smokecrib>(),
        leaffilterlist:new Array<Smokecrib>(),
        loading:false,
        editSmokecrib:new Smokecrib()
    }
    actions={
        async getAll(context:ActionContext<SmokecribState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokecrib>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<SmokecribState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokecrib>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<SmokecribState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokecrib>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async getlistfilter(context:ActionContext<SmokecribState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetListByleaf',{params:payload.data});
            context.state.loading=false;
            context.state.leaffilterlist=reponse.data.result;
        },
        async getsel(context:ActionContext<SmokecribState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokecrib>;
            context.state.totalCount=page.totalCount;
            return  page.items;
        },
        async create(context:ActionContext<SmokecribState,any>,payload:any){
            await Ajax.post('/api/services/app/ThSmokecrib/Create',payload.data);
        },
        async uploadimg(context:ActionContext<SmokecribState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<SmokecribState,any>,payload:any){
            await Ajax.put('/api/services/app/ThSmokecrib/Update',payload.data);
        },
        async delete(context:ActionContext<SmokecribState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThSmokecrib/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<SmokecribState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThSmokecrib/GetById?Id='+payload.id);
            return reponse.data.result as Smokecrib;
        }
    };
    mutations={
        setCurrentPage(state:SmokecribState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:SmokecribState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:SmokecribState,smokecrib:Smokecrib){
            
            state.editSmokecrib=smokecrib;
            //console.log(state.editFloor);
        }
    }
}
const smokecribModule=new SmokecribModule();
export default smokecribModule;